export default __webpack_public_path__ + "d583b1fcbd557ddc1e40437f82f8ad2d.svg";